module.exports = __webpack_public_path__ + "fonts/Inter-600-latin63.260c81a.woff2";